var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Banners'),_c('ReferralLink'),_c('div',{staticClass:"row"},_vm._l((_vm.statData),function(stat,index){return _c('div',{key:index,staticClass:"col-md-4 col-lg-4 col-xl-4"},[_c('Stat',{attrs:{"type":stat.type,"icon":stat.icon,"title":stat.title,"value":stat.value}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }